import { OneTimeTokenDialog } from "@/components/OneTimeTokenDialog";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  agentId: string;
  token: string;
}

// Backwards-Compat Wrapper. Neuer Code soll direkt OneTimeTokenDialog nutzen.
export function AgentTokenDisplay({ open, onOpenChange, agentId, token }: Props) {
  return (
    <OneTimeTokenDialog
      open={open}
      onOpenChange={onOpenChange}
      title={`Agent erstellt: ${agentId}`}
      description="Token wurde generiert. Bitte JETZT kopieren — er wird nicht mehr angezeigt werden."
      label="Agent-Token"
      token={token}
    />
  );
}
